enum CustomerType {
  Individual = 'Individual',
  Company = 'Company',
  Chapter = 'Chapter',
}

export default CustomerType;
